<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadInquiries(1, null,true)">

      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('inquiry_name')" v-model="inquiryFormData.name" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationInquiryButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addInquiry">{{ $t('classification_added') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('inquiry_name')" v-model="inquirySearchParams.inquiry" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('status')" v-model="inquirySearchParams.isActive"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadInquiries(1, null,true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="inquiryDataContainer" :title="$t('inquiry')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-consultation-inquiries-list
        :inquiries="inquiries"
        @customClickStatus="status"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-consultation-inquiries-list>

      <template slot="footer">
        <paginate
          :total="inquiryPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadInquiries"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import Inquiry from '@/models/Inquiry'
import SharedUserConfigurationConsultationInquiriesList from '@/views/Shared/Configuration/Consultation/Inquiries/List'
import Paginate from '@/mixins/paginate'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Configuration.Consultation.Inquiry',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationConsultationInquiriesList
  },
  data () {
    return {
      inquiriesEdit: {},
      inquiries: {},
      inquiryPages: 1,
      inquiryFormData: {
        name: '',
        is_active: '',
        id: ''
      },
      inquiryFormErrors: {},
      itemPerPage: null,
      inquirySearchParams: {
        inquiry: typeof this.$route.query.inquiry !== 'undefined' ? this.$route.query.inquiry : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions
    }
  },
  mounted () {
    this.loadInquiries(this.initialPage, null, false, true)
  },
  methods: {
    async loadInquiries (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#inquiryDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: {...this.groupSearchParams, page, itemPerPage}})
      }
      const response = await Inquiry.all({ ...this.inquirySearchParams, page, itemPerPage })
      this.inquiries = response.data.data.inquiries
      this.inquiryPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#inquiryDataContainer > .con-vs-loading')
    },
    async addInquiry (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationInquiryButton', scale: 0.45})
      if (this.inquiryFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_inquiry_error_message'),
          confirmButton: this.$t('confirm')
        })

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await Inquiry.save(this.inquiryFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadInquiries(1, this.itemPerPage)
        this.inquiryFormData = {
          name: '',
          is_active: '',
          id: ''
        }
        this.inquiryFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationInquiryButton > .con-vs-loading')
    },
    async status (key) {
      try {
        if (this.inquiries[key].is_active === 1) {
          this.inquiries[key].is_active = 0
        } else {
          this.inquiries[key].is_active = 1
        }
        await Inquiry.update(this.inquiries[key])
        this.inquiries[key].inquiryFormErrors = {}
      } catch (e) {
        this.inquiries[key].inquiryFormErrors = e.response.data.errors
      }
    },
    async edit (key) {
      this.inquiries[key].edit = true
      const editElem = this.inquiries[key]
      const editObj = {
        name: editElem.name
      }
      this.inquiriesEdit[key] = editObj
    },
    async cancel (key) {
      this.inquiries[key].name = this.inquiriesEdit[key].name
      this.inquiries[key].edit = false
      this.inquiries[key].inquiryFormErrors = {}
      delete this.inquiriesEdit[key]
    },
    async save (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('inquiry_update_confirmation_title'),
          text: this.$t('inquiry_update_confirmation_text'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationInquiryButton${id}`, scale: 0.45})
          await Inquiry.update(this.inquiries[key])
          this.inquiries[key].edit = false
          this.inquiries[key].inquiryFormErrors = {}
          this.$vs.loading.close(`#updateConfigurationInquiryButton${id} > .con-vs-loading`)
        }
      } catch (e) {
        this.inquiries[key].inquiryFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateConfigurationInquiryButton${id} > .con-vs-loading`)
      }
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Inquiry.delete(id)
        this.loadInquiries(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationInquiryButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
